import {createAsyncThunk} from "@reduxjs/toolkit";
import {$clientApi} from "../../http";
import {IStripeKeyResponse} from "../../models/Payment";


export const getStripeKey = createAsyncThunk('stripeKeys/getStripeKey', async (_, thunkAPI) => {
    try {
        const response = await $clientApi.get<IStripeKeyResponse>(`api/online-payment/stripe-key?api_version=2022-11-15`);
        return response.data;
    } catch (e) {
        return thunkAPI.rejectWithValue("error");
    }
});